/** Shared `myMemberInfo` data-access layer — the base fetch every member-scoped feature reads from. */

import { gqlRequest } from '@mdvip/shared/lib/graphql-client';
import { MyMemberInfoDocument, type MyMemberInfoQuery } from '@/graphql/generated/graphql';

export type MyMemberInfo = MyMemberInfoQuery['myMemberInfo'];

/**
 * Shared across Payments' billing/AutoPay/balance views and Profile's {@link useMyProfile} (same
 * queryKey, different `select`) so mounting more than one of them at once doesn't fire the query
 * twice, and by the add-card/add-bank-account mutations so one invalidate refreshes all of them.
 */
export const memberInfoKey = ['member', 'myMemberInfo'] as const;

export async function requestMyMemberInfo(): Promise<MyMemberInfo> {
  const data = await gqlRequest(MyMemberInfoDocument);
  return data.myMemberInfo;
}
